// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","481":"020d8314","883":"3a8f01e0"}[chunkId] || chunkId) + "-" + {"245":"fd99a4a3eb8b053b2ba3","453":"3bf98db7580ab6c7bf63","481":"01292b6caf42b483c6e8","883":"87cf6738b7fc233c7fce","930":"1f81bfaf7c86bb98327e"}[chunkId] + ".js";
};